module.exports = __webpack_public_path__ + "static/media/virgin_card_5.6ed7c491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/virgin_card_5.jpg
// module id = 531
// module chunks = 0